import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HousingInfoService } from '../../../../../services/housing-info/housing-info.service';
import { LoadingIndicatorService } from '../../../../../services/loading-indicator/loading-indicator.service';
import { EventsService } from '../../../../../services/events/events.service';
import { environment } from '../../../../../../environments/environment';
import { ExternalOfferSource } from '@tripbakers/enums';

@Component({
  selector: 'app-housing-info-details-expedia-connect',
  templateUrl: './expedia-connect.component.html',
  styleUrls: ['./expedia-connect.component.css'],
})
export class HousingInfoDetailsExpediaConnectComponent implements OnInit {
  @Input('housing') housing;
  form: FormGroup;
  isLoading = false;

  constructor(
    private http: HttpClient,
    private housingInfoService: HousingInfoService,
    private loadingIndicatorService: LoadingIndicatorService,
    private eventsService: EventsService
  ) {
    this.form = new FormGroup({
      isExpediaEnabled: new FormControl({ value: false, disabled: false }),
      preOfferDrafts: new FormControl({ value: false, disabled: false }),
    });
  }

  onSubmitForm() {
    if (this.form.status !== 'VALID') {
      console.log('INVALID');
      this.validateAllFormFields(this.form);
      return;
    }
    this.showLoading();

    this.postData().subscribe(
      (response: any) => {
        this.hideLoading();
        this.housingInfoService.setSelectedHousing(response);
      },
      (err) => {
        if (err.error.message === 'E_VALIDATION_FAILED') {
          try {
            for (const error of err.error.errors) {
              this.form.get(error.property).setErrors(error.constraints);
              this.form.get(error.property).markAsDirty();
            }
          } catch (error) {
            console.log('Catched E', error);
          }
          this.hideLoading();
          return;
        } else if (err.error.message === 'E_HOUSING_HAS_CHANNELMANAGER') {
          this.eventsService.broadcast(
            'requestShowErrorMessage',
            'Channel Manager is enabled for this housing. Please disable the Channel Manager before enabling Expedia Connect.'
          );
          this.hideLoading();
          return;
        } else if (
          err.error.message === 'E_EXTERNAL_SOURCE_OFFER_NO_ID_FOUND'
        ) {
          this.eventsService.broadcast(
            'requestShowErrorMessage',
            'The Expedia ID is missing for this housing. Please set the Expedia ID before enabling Expedia Connect.'
          );
          this.hideLoading();
          return;
        }

        this.hideLoading();
        this.eventsService.broadcast(
          'requestShowErrorMessage',
          JSON.stringify(err)
        );
      }
    );
  }

  private postData() {
    return this.http.patch(
      environment.urls.service +
        '/api/v1/authenticated/admin/housing/' +
        this.housing._id +
        '/external-source-offer/settings',
      {
        enabled: this.form.get('isExpediaEnabled').value,
        preOfferDrafts: this.form.get('preOfferDrafts').value,
        provider: ExternalOfferSource.EXPEDIA,
      }
    );
  }

  ngOnInit() {
    if (this.housing != null) {
      this.mapHousingToForm();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.housing.currentValue != null) {
      this.housing = changes.housing.currentValue;
      this.mapHousingToForm();
    }
  }

  private validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  private mapHousingToForm() {
    const externalDetails = this.housing.externalSourceOfferDetails;
    const preOfferDraft = this.housing.preOfferDraftDetails;
    const vals = {
      isExpediaEnabled: !!externalDetails && !!externalDetails.enabled,
      preOfferDrafts: !!preOfferDraft && !!preOfferDraft.enabled,
    };
    this.form.setValue(vals);

    this.enableDisableFormCtrl();
  }

  private enableDisableFormCtrl() {
    const enable = this.housing != null;
    for (const key in this.form.controls) {
      if (this.form.controls.hasOwnProperty(key)) {
        if (enable) {
          this.form.controls[key].enable();
        } else {
          this.form.controls[key].disable();
        }
      }
    }
  }

  public returnEmptyStringWhenNull(element) {
    return element == null ? '' : element;
  }

  public extractValidationErrorsAsArray(errors) {
    if (errors == null) {
      return [];
    }

    const errorsToReturn = [];
    Object.keys(errors).forEach((key) => {
      errorsToReturn.push(errors[key]);
    });

    return errorsToReturn;
  }

  public showLoading() {
    this.isLoading = true;
    this.loadingIndicatorService.showLoadingBar();
  }

  public hideLoading() {
    this.isLoading = false;
    this.loadingIndicatorService.hideLoadingBar();
  }
}
